import { ElementRef, Injectable} from '@angular/core'
import { Camera, CameraResultType } from '@capacitor/camera'
import { Device } from '@capacitor/device'
import { AppStorageService } from '../app-storage.service';
import { StorageKeys } from '../storage-keys';
@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor(private storage: AppStorageService) {}

  imageUrl: any

  takePicture = async () => {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: false,
      resultType: CameraResultType.Uri,
      promptLabelHeader: 'Foto',
      promptLabelPhoto: 'Desde Galería',
      promptLabelPicture: 'Tomar foto',
      promptLabelCancel: 'Cancelar'
    })

    this.imageUrl = image.webPath
    return this.imageUrl
  }

  async detectIsWeb(): Promise<boolean> {
    const info = await Device.getInfo()
    return info.platform === 'web'
  }

  async isLoggedIn() {
    const user = this.storage.get(StorageKeys.USER)
    return !!user
  }


  resizeScale(elemento: ElementRef<HTMLElement>, originalWidth: number, originalHeight: number) {
    if (!elemento) return;

    const el = elemento.nativeElement;
    const escalaX = window.innerWidth / originalWidth;
    const escalaY = window.innerHeight / originalHeight;
    const escala = Math.min(escalaX, escalaY);

    el.style.transform = `scale(${escala})`;
  }
}
